import React from 'react';
export function FooterSection() {
  return <footer className="w-full bg-[#1A2B4A] border-t border-white/10 py-10 px-6" data-id="element-241">
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-6" data-id="element-242">
        <img src="https://cdn.magicpatterns.com/uploads/7VaFeJZzD28sKMP5WawxYb/HIRE_White_Logo.png" alt="The Hire Advantage" className="h-10 object-contain opacity-80" data-id="element-243" />
        <p className="text-[#4ECDC4]/70 text-sm font-medium text-center italic" data-id="element-244">
          Built by D2D operators. For D2D operators.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6" data-id="element-245">
          <p className="text-white/30 text-sm text-center" data-id="element-246">
            © {new Date().getFullYear()} The Hire Advantage. All rights
            reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-247">
            <a href="https://get.thehireadvantage.co/privacypolicy" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-sm transition-colors" data-id="element-248">
              Privacy Policy
            </a>
            <span className="text-white/20" data-id="element-249">|</span>
            <a href="https://get.thehireadvantage.co/terms" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-white/60 text-sm transition-colors" data-id="element-250">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}